// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"a857a896","177":"ad8b9eb3","770":"5b25fc0b"}[chunkId] + ".js";
};